<div>
    <div>
        <title>{{ productName }}</title>
        <div class="sub-text">Incident detection, visibility, discovery and management</div>
        <p>FortiSIEM brings together visibility, correlation, analytics, UEBA, discovery and reporting into a single
            solution. It reduces the complexity of managing network and security operations to effectively free
            resources, improve incident detection, and even prevent breaches. FortiSIEM Cloud simplifies the
            implementation and ongoing management for organisations and MSSP’s, allowing them to focus on incident
            detection and management.</p>
        <p>See <a href="https://www.fortinet.com/products/siem/fortisiem" rel="noopener noreferrer"
                target="_blank">here</a> for more information</p>
    </div>
    <div><img src="assets/logos/icon-library-fortisiem-cloud_colour.svg" alt="FortiSIEM Cloud" /></div>
</div>
